(function () {
  /**
   * @ngdoc module
   * @name binky.core.invitation
   * @description Module which defines invite related model(s)
   */
  angular.module('binky.core.invitation', ['binky.core.api.jil', 'binky.core.lodash']);
})();
